import { render, staticRenderFns } from "./CardDetailEntry.vue?vue&type=template&id=ff963b7e"
import script from "./CardDetailEntry.vue?vue&type=script&lang=js"
export * from "./CardDetailEntry.vue?vue&type=script&lang=js"
import style0 from "./CardDetailEntry.vue?vue&type=style&index=0&id=ff963b7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports